module.exports = __webpack_public_path__ + "static/media/home-step-icon-white.21928762.svg";